import React, { FC, useMemo } from 'react'
import ConfigBadge from '~/app/components/common/Badge/ConfigBadge'
import { ConfigBadgeType } from '~/api/utils/leisure'

interface ConfigBadgeGroupProps {
  badges?: string[]
}

const ordering = {
  [ConfigBadgeType.PENDING_RESERVATION]: 0,
  [ConfigBadgeType.MILLION_COUPON]: 10,
  [ConfigBadgeType.ONE_OFF_PROMOTION]: 11,
  [ConfigBadgeType.LEISURE_COUPON]: 12,
  [ConfigBadgeType.MILLION_COUPON_MOTEL]: 13,
  [ConfigBadgeType.CANCEL_PENALTY]: 20,
  [ConfigBadgeType.PAYBACK]: 21,
  [ConfigBadgeType.DAY_USE]: 30,
  [ConfigBadgeType.Y_FLUX]: 40,
}

const ConfigBadgeGroup: FC<ConfigBadgeGroupProps> = ({ badges }) => {
  const reorderBadges = useMemo<JSX.Element[]>(() => {
    const reorder: string[] = [...(badges ?? [])]
    return reorder
      .sort((a, b) => ordering[a] - ordering[b])
      .map((type, idx) => <ConfigBadge key={idx} badgeType={type} />)
  }, [badges])

  return <>{reorderBadges}</>
}

export default ConfigBadgeGroup
